module.exports = __webpack_public_path__ + "static/media/view_profile.b96f4fe2.svg";